import { useMemo } from 'react';

import operatorProductSerialNumberService from '@services/operator/productSerialNumberService';

// Re-export 型別給 caller，省去跨層 import service 模組
export type {
  ProductSerialNumberDetail,
  ProductSerialNumberInventory,
  ProductSerialNumberRecord,
  ProductSerialNumberStatus,
  ProductSerialNumberTimelineEvent,
  ProductSerialNumberTimelineEventType,
} from '@services/operator/productSerialNumberService';

/**
 * Operator Product Serial Number Service Hook
 *
 * 包裝 operatorProductSerialNumberService。merchant_id / warehouse_id 由
 * operatorApiFetch 透過全域 header 自動注入（見 services/operator/apiService.ts），
 * 故這層 hook 不需要 inject 任何 context 參數，shape 與 useOperatorProductService 不同
 * （後者要 inject merchant_id 是因 BE 端點直接吃 query param，PSN 端點則完全靠 base_scope 隔離）。
 *
 * 注意：operator 端 BE 強制 status='in_stock' + current_warehouse + accessible merchants，
 * client 端可送 status[] 但會被 silent ignore（per Task 5 BE 設計）。
 *
 * @example
 * const psnService = useOperatorProductSerialNumberService();
 *
 * const list = await psnService.getRecords({ numbers: ['SN-0001'] });
 * const detail = await psnService.getById('abc-uuid');
 */
export function useOperatorProductSerialNumberService() {
  return useMemo(() => operatorProductSerialNumberService, []);
}
